import { Component } from '@angular/core';

import { ActivatedRoute, RouterModule } from '@angular/router';

import { departmentsPerformance } from '../../providers/static-data';
import { BarChartComponent } from "../../components/charts/bar-chart.component";
import { PerformanceApiService } from './performance-api.service';
import { debounce } from 'lodash';
import { FormsModule } from '@angular/forms';
import { FilterBaseAccessService } from '../../auth/filterbase-access';
import { CommonModule } from '@angular/common';
import { finalize } from 'rxjs';
import { ConfomerService } from '../../providers/confomer/confomer.service';
import { ToasterService } from '../../providers/toaster/toaster.service';

@Component({
  selector: 'app-performance-view',
  standalone: true,
  imports: [RouterModule, BarChartComponent, FormsModule, CommonModule],
  templateUrl: './performance-view.component.html',
  styleUrl: './performance-view.component.css'
})
export class PerformanceViewComponent {
  
  type: any = ''
  id: number = 0
  data:any
  searchStr:string = ''
  paginationData:any
  currentPage:any

  tableColumns = {
    department:['student name','overall','video','flashcard','ai-test'],
    group:['student name','overall','video','flashcard','ai-test'],
    class:['class','batch','overall','video','flashcard','ai-test'],
  }

  performance: boolean = false;
  profile: boolean = false;
  canViewPerformance: boolean = false;
  video_performance: boolean = false;
  flashcard_performance: boolean = false;
  ai_test_performance: boolean = false;
  year_filter_performance: boolean = false;
  overall_performance_list: boolean = false;
  performance_view_student: boolean = false;
  performance_communicate: boolean = false;
  removingStudentId: number | null = null;

  constructor(
    private route: ActivatedRoute,
    private performanceApiService: PerformanceApiService,
    private access: FilterBaseAccessService,
    private conformer: ConfomerService,
    private toasterService: ToasterService
  ) {
    this.route.params.subscribe(params => {
      this.type = params['type'];
      this.id = Number(params['id']);
      this.updatePermissions();
    });
  }

  private updatePermissions() {
    const performanceActionSlug = this.getPerformanceActionSlug(this.type);

    this.performance = this.access.checkaccessforfiltersandactions('performance');
    this.profile = this.access.checkaccessforfiltersandactions('profile');
    this.canViewPerformance = this.performance || this.access.checkaccessforfiltersandactions(performanceActionSlug);

    if (!this.profile) {
      this.profile = this.canViewPerformance;
    }

    this.video_performance = this.access.checkaccessforfiltersandactions('video performance');
    this.flashcard_performance = this.access.checkaccessforfiltersandactions('flashcard performance');
    this.ai_test_performance = this.access.checkaccessforfiltersandactions('ai test performance');
    this.year_filter_performance = this.access.checkaccessforfiltersandactions('year filter');
    this.overall_performance_list = this.access.checkaccessforfiltersandactions('overall performance list');
    this.performance_view_student = this.access.checkaccessforfiltersandactions('performance view student');
    this.performance_communicate = this.access.checkaccessforfiltersandactions('performance communicate');
  }

  private getPerformanceActionSlug(type: string): string {
    switch ((type || '').toLowerCase()) {
      case 'department':
        return 'department performance';
      case 'group':
        return 'group performance';
      case 'class':
        return 'class performance';
      default:
        return 'performance';
    }
  }


  ngOnInit() {
    this.getData();
  }

  getData() {
    this.performanceApiService.getPerformance(this.type.toUpperCase(), this.id,this.currentPage,this.searchStr)?.pipe().subscribe({
      next: (res: any) => {
        this.data = res.data;
      },
    })
  }


  serach = debounce(() => {
    this.getData();
  }, 500)


  getColumns(type: 'department' | 'group' | 'class') {
    return this.tableColumns[type];
  }

  getStudentRecordId(student: any): number | null {
    return student?.id ?? student?.student_id ?? student?.master_student_profile_id ?? null;
  }

  async removeStudentFromGroup(student: any) {
    if (this.type !== 'group' || !this.id || !student?.id || this.removingStudentId) {
      return;
    }

    const studentName = `${student?.first_name ?? ''} ${student?.last_name ?? ''}`.trim() || 'this student';
    const confirmed = await this.conformer.Open(
      'Remove Student',
      `Are you sure you want to remove ${studentName} from this group?`
    );

    if (!confirmed) {
      return;
    }

    this.removingStudentId = student.id;
    this.performanceApiService.removeStudentFromGroup(this.id, student.id)
      .pipe(finalize(() => {
        this.removingStudentId = null;
      }))
      .subscribe({
        next: (res: any) => {
          if (res.status === 'success') {
            this.toasterService.setToaster('success', 'Student Removed', res.message || 'Student removed from group successfully');
            this.getData();
          }
        },
        error: (err) => {
          console.error('HTTP error:', err);
        }
      });
  }



}
